<form [formGroup]="negotiationForm">
    <div class="container">
        <div class="title-container">
            <h2 class="mat-title">{{ !data.isDuplication ? "Ajout d'une négociation" : "Duplication d'une négociation" }}</h2>
        </div>

        <ng-container *ngIf="!isSaving; else savingContentTemplate">
            <div class="tv-ns-custom-horizontal-divider"></div>
            <div class="dialog-form-content tv-custom-always-visible-scroll-bar" [attr.aria-busy]="isLoading">
                <div class="dialog-fields" [attr.inert]="isLoading ? '' : null">
                    <div class="bloc-container">
                        <h4 class="red-title">Général</h4>
                        <div class="inputs-container">
                            <!-- Negotiation Type -->
                            <div class="tv-rect-input-extensible flex-auto">
                                <mat-form-field>
                                    <mat-label>Type de négotiation</mat-label>
                                    <input
                                        class="tv-ns-select-option"
                                        type="text"
                                        matInput
                                        [formControl]="negotiationTypeFormControl"
                                        [matAutocomplete]="auto" />
                                    <mat-autocomplete
                                        autoActiveFirstOption
                                        class="tv-custom-always-visible-scroll-bar"
                                        #auto="matAutocomplete"
                                        [displayWith]="displayNegotiationType">
                                        <mat-option
                                            *ngFor="let negotiationType of filteredNegotiationTypeList | async"
                                            class="tv-ns-select-option"
                                            [value]="negotiationType">
                                            {{ negotiationType.id }} - {{ negotiationType.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div
                                    class="tv-input-error-message"
                                    *ngIf="negotiationTypeFormControl.touched && negotiationTypeFormControl.hasError('required')">
                                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                                    <span class="tv-input-error-text">Veuillez choisir un type de négociation</span>
                                </div>
                            </div>

                            <!-- Date Range -->
                            <custom-date-range-picker
                                [ngModel]="{ start: negotiationForm.get('startDate')?.value, end: negotiationForm.get('endDate')?.value }"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="negotiationForm.patchValue({ startDate: $event ? $event.start : null, endDate: $event ? $event.end : null })"
                                [min]="negotiationForm.get('startDate')?.value"
                                [max]="negotiationForm.get('endDate')?.value"
                                [styleType]="'squared'"
                                valueFormat="dd/MM/yyyy"
                                [required]="true">
                            </custom-date-range-picker>

                            <!-- Rate  -->
                            <div>
                                <div class="rate">
                                    <button class="tv-chip-icon-rate-button-medium-light-blue">
                                        <mat-chip-listbox class="tv-container-rate-chip-set-button">
                                            <mat-chip-option
                                                *ngFor="let view of displayViews"
                                                (click)="selectedDisplayView(view)"
                                                [selected]="this.selectedView === view?.id">
                                                {{ view.display }}
                                            </mat-chip-option>
                                        </mat-chip-listbox>
                                    </button>
                                    <div class="tv-rect-input-extensible">
                                        <mat-form-field>
                                            <mat-label>Montant de la remise</mat-label>
                                            <input type="number" matInput [formControl]="rateFormControl" (blur)="enforceNegativeRate()" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="tv-input-error-message" *ngIf="rateFormControl.touched && rateFormControl.hasError('required')">
                                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                                    <span class="tv-input-error-text">Veuillez saisir un taux ou une valeur</span>
                                </div>
                                <div class="tv-input-error-message" *ngIf="rateFormControl.touched && rateFormControl.hasError('maxRateExceeded')">
                                    <mat-icon class="tv-input-error-icon">error</mat-icon>
                                    <span class="tv-input-error-text">Valeur comprise entre -999 et 999</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="hasMultipleIncludeGroups && conditionSummaryRows.length > 0" class="bloc-container">
                        <h4 class="red-title">Combinaisons de conditions ({{ conditionSummaryRows.length }})</h4>
                        <div class="condition-summary-table-container">
                            <div class="condition-summary-scroll tv-custom-always-visible-scroll-bar">
                                <table mat-table [dataSource]="conditionSummaryRows" class="tv-ns-mat-table tv-ns-large-mat-table condition-summary-table">
                                    <ng-container *ngFor="let column of conditionSummaryColumns" [matColumnDef]="'category-' + column.id">
                                        <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
                                        <td mat-cell *matCellDef="let row">
                                            <span class="condition-summary-cell"
                                                  [matTooltip]="row[column.id] ?? ''"
                                                  matTooltipClass="custom-tv-tooltip">{{ row[column.id] }}</span>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="conditionSummaryColumnIds; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: conditionSummaryColumnIds"></tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!-- Conditions Template -->
                    <div class="cond-container" [class.multiple-include-groups]="hasMultipleIncludeGroups">
                        <ng-template #dynamicConditionComponent></ng-template>
                    </div>

                    <!-- Add Conditions-->
                    <div *ngIf="hasAvailableConditionCategories" class="add-category-bloc-container">
                        <span>Conditions</span>
                        <span
                            class="add-condition-button-wrapper"
                            matTooltip="Sélectionnez au moins une condition avant d’ajouter un nouveau groupe."
                            matTooltipClass="custom-tv-tooltip"
                            [matTooltipDisabled]="!isAddConditionDisabled"
                            [attr.tabindex]="isAddConditionDisabled ? 0 : null">
                            <button
                                type="button"
                                class="tv-icon-button-s-transparent add-condition-button"
                                aria-label="Ajouter un groupe de conditions"
                                [disabled]="isAddConditionDisabled"
                                (click)="createDynamicConditionComponent(1, 'Inclus')">
                                <mat-icon class="type-icon" svgIcon="add-circle-fill"></mat-icon>
                            </button>
                            <!--                <mat-icon-->
                            <!--                        class="type-icon"-->
                            <!--                        svgIcon="delete-circle-fill"-->
                            <!--                        (click)="createDynamicConditionComponent(0, 'Exclus')"-->
                            <!--                >-->
                            <!--                </mat-icon>-->
                        </span>
                    </div>

                </div>
                <div *ngIf="isLoading" class="loading-overlay" role="status" aria-label="Chargement du formulaire">
                    <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                </div>
            </div>

            <div class="button-edit">
                <button type="button" class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler</button>
                <button type="submit" class="tv-ns-validation-large-button" [disabled]="isLoading" (click)="onValidationButtonClick()">Valider</button>
            </div>
        </ng-container>
        <ng-template #savingContentTemplate>
            <div class="saving-content">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </ng-template>
    </div>
</form>
